/**
 * 
 * key
 * 
 */


const key = 'Y3VzdG9tX2ZpZWxk'

export default key 